export default __webpack_public_path__ + "static/bathroom-713248_1280-d2f0ed20ffe2749beaf5198453baf062.png";